export const topics = [
  `가장 좋아하는 캐릭터에 대해서 써볼까요?`,
  `기르는 반려동물이 있다면 같이 무엇을 하나요?`,
  `가장 좋아하는 계절이 있나요? \n왜 좋아하는지 써보아요.`,
  `최근에 친구랑 했던 가장 \n재밌는 놀이는 무엇인가요?`,
  `어른이 되면 무슨 일을 하고 싶나요? \n꿈과 미래에 대해서 써보아요.`,
  `나의 가족에 대해서 써보아요. \n가족들과 함께 보낸 특별한 순간이 있나요?`,
  `최근에 읽은 책이 있다면 어떤 내용인지, \n읽으면서 어떤 생각이 들었는지 써보아요.`,
  `제일 좋아하는 음식이 무엇인가요? \n레시피도 함께 적어보아요.`,
  `가장 기억에 남는 꿈이 있나요? \n꿈 속에서 누구와 무엇을 했는지 적어보아요`,
  `학교에서 생긴 재미있는 사건이나 \n친구들과의 경험이 있나요?`,
  `기억에 남는 여행이 있나요? \n어디에서 무엇을 했는지 써보아요.`,
  `스포츠 경기를 관람한 적이 있나요? \n그때의 기분은 어땠는지 적어보아요.`,
  `가장 좋아하는 사람이 있나요? \n그 사람은 어떤 사람인지 적어보아요.`,
  `자신만의 비밀 공간이 있나요? \n그곳에서 주로 무엇을 하나요?`,
  `제일 좋아하는 노래에 대해 써볼까요?`,
  `가장 좋아하는 동물은 무엇인가요? \n그 동물의 특징에 대해 써볼까요?`,
  `가보고 싶은 여행지가 있나요? \n그곳에서 누구와 무엇을 하고 싶나요?`,
  `내가 슈퍼히어로라면 \n어떤 능력과 임무를 갖게 될까요?`,
  `수업시간에 한 활동 중 기억에 \n남는 재밌는 활동이 있나요?`,
  `고마운 친구가 있다면 \n그 친구에서 감사편지를 써보아요.`,
  `나만의 판타지 세계를 상상해보아요. \n어떤 세계에서 살고 싶나요?`,
  `가장 특별한 선물에 대해 써보아요. \n누구에게 무엇을 받았나요?`,
  `제일 좋아하는 과일이나 야채는 무엇인가요? \n그걸로 어떤 요리나 간식을 만들 수 있을까요?`,
  `가장 좋아하는 보드게임이나 비디오게임이 있나요? 그 게임의 특징에 대해 써보아요.`,
  `어떤 운동을 가장 좋아하나요? \n그 운동을 할 땐 어떤 기분이 드나요?`,
];
